import ru_mygames_kit_config from "@libs/authorization/projects/wf/ru_mygames_kit_config";
import eu_mygames_kit_config from "@libs/authorization/projects/wf/eu_mygames_kit_config";
import store from "../model/store/index";

import env from "@libs/util/environment";
let kit_config;
if (env.isMailRu()) {
  kit_config = ru_mygames_kit_config;
} else {
  kit_config = eu_mygames_kit_config;
}
import MinigamesApi from "@libs/api/MinigamesApi";
const api = new MinigamesApi();
export default {
  kit_config,
  api,
  store,
};
